import axios from 'axios';

import { BasicUserInfo } from '../interfaces/BasicUserInfo';
import { PagingResult } from '../interfaces/pagination';

export interface SpecFeedbackType {
  id: number
  authorId: string
  author?: BasicUserInfo
  specId: string
  description: string
  status: string
  createdAt: string
  updatedAt: string
}

export interface FindOptions {
  specId?: string
  status?: string
  [key: string]: any
}

class SpecFeedback implements SpecFeedbackType {
  id: number
  authorId: string
  author?: BasicUserInfo
  specId: string
  description: string
  status: string
  createdAt: string
  updatedAt: string

  constructor(feedback: SpecFeedbackType) {
    this.id = feedback.id;
    this.authorId = feedback.authorId;
    this.author = feedback.author;
    this.specId = feedback.specId;
    this.description = feedback.description;
    this.status = feedback.status;
    this.createdAt = feedback.createdAt;
    this.updatedAt = feedback.updatedAt;
  }

  // creates new spec feedback
  static async create(feedback: Partial<SpecFeedbackType>): Promise<SpecFeedback> {
    const { data } = await axios.post<SpecFeedbackType>('/spec/feedback', feedback);
    return new SpecFeedback(data);
  }

  // returns spec feedback list
  static async find(query?: FindOptions): Promise<PagingResult<SpecFeedback>> {
    const { data } = await axios.get<PagingResult<SpecFeedbackType>>('/spec/feedback/list', {
      params: query
    });
    return { ...data, items: data.items.map(s => new SpecFeedback(s)) };
  }

  // sets feedback status
  async setStatus(status: string): Promise<SpecFeedback> {
    const { data } = await axios.put<SpecFeedbackType>('/spec/feedback/status', { status }, {
      params: { id: this.id }
    });
    return new SpecFeedback(data);
  }
}

export default SpecFeedback;
